"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCanvasPosition = exports["default"] = exports.EditorContainer = exports.CanvasPositionContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssElementQueries = require("css-element-queries");
var _Canvas = require("../../CanvasInterface/Canvas");
var _CanvasProvider = require("../../CanvasInterface/CanvasProvider");
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
var _String = require("../../Utils/String");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('EditorContainer');
var initialState = {
  canvasPosition: {
    left: 0,
    top: 0
  },
  editorSize: {
    width: 0,
    height: 0
  },
  ratio: 1,
  containerStyle: {}
};
var CanvasPositionContext = exports.CanvasPositionContext = /*#__PURE__*/_react["default"].createContext(initialState);
var EditorContainer = exports.EditorContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(EditorContainer, _React$Component);
  var _super = _createSuper(EditorContainer);
  function EditorContainer() {
    var _this;
    _classCallCheck(this, EditorContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", initialState);
    _defineProperty(_assertThisInitialized(_this), "resizeSensor", null);
    _defineProperty(_assertThisInitialized(_this), "onSizeChange", function (size) {
      _this.setState({
        editorSize: size
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCanvasSizeChange", function () {
      logger.log('canvas size changed, updating canvas position');
      _this.updateCanvasPosition();
    });
    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "calculateSiblingsHeight", function () {
      var element = _this.containerRef.current;
      if (!element) {
        return 0;
      }
      var sum = 0;
      var children = _toConsumableArray(element.parentElement.children);
      children.forEach(function (child) {
        sum += child === element || child.className === 'resize-sensor' ? 0 : child.getBoundingClientRect().height;
      });
      return sum;
    });
    _defineProperty(_assertThisInitialized(_this), "calculateContainerStyle", function () {
      var wrapper = _this.containerRef.current && _this.containerRef.current.parentElement;
      var _this$props = _this.props,
        fillContainer = _this$props.fillContainer,
        canvas = _this$props.canvas,
        style = _this$props.style;
      if (!fillContainer && canvas && wrapper) {
        // set the max size to the minimum of current canvas size and the available area
        var _canvas$getElementSiz = canvas.getElementSize(),
          cw = _canvas$getElementSiz.width,
          ch = _canvas$getElementSiz.height;
        var _wrapper$getBoundingC = wrapper.getBoundingClientRect(),
          aw = _wrapper$getBoundingC.width,
          ah = _wrapper$getBoundingC.height;
        var aspectRatio = cw / ch;
        var width, height;
        if (aspectRatio < 1) {
          height = Math.min(ch, ah);
          width = height * aspectRatio;
        } else {
          width = Math.min(cw, aw);
          height = width / aspectRatio;
        }
        return _objectSpread({
          width: '100%',
          height: '100%',
          maxWidth: width,
          maxHeight: height
        }, style);
      }
      return style;
    });
    return _this;
  }
  _createClass(EditorContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.containerRef.current;
      var parent = container.parentElement;

      // register ResizeSensor in the parent to detect container size changes
      this.resizeSensor = new _cssElementQueries.ResizeSensor(parent, this.onSizeChange);
      // initial size change should be called
      var _parent$getBoundingCl = parent.getBoundingClientRect(),
        width = _parent$getBoundingCl.width,
        height = _parent$getBoundingCl.height;
      this.onSizeChange({
        width: width,
        height: height
      });
      var _this$props2 = this.props,
        onContainerReady = _this$props2.onContainerReady,
        canvas = _this$props2.canvas;
      if (onContainerReady) {
        this._unmountCallback = onContainerReady({
          container: container
        });
      }
      if (canvas) {
        canvas.on(_Canvas.CanvasEvents.OnSizeChange, this.onCanvasSizeChange);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeSensor && this.resizeSensor.detach();
      if (this._unmountCallback) {
        this._unmountCallback();
      }
      this.props.canvas && this.props.canvas.off(_Canvas.CanvasEvents.OnSizeChange, this.onCanvasSizeChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var editorSize = this.state.editorSize;
      var _this$props3 = this.props,
        canvas = _this$props3.canvas,
        selectedColor = _this$props3.selectedColor;
      var prevCanvas = prevProps.canvas,
        prevSelectedColor = prevProps.selectedColor;
      if (canvas && canvas !== prevCanvas) {
        prevCanvas && prevCanvas.off(_Canvas.CanvasEvents.OnSizeChange, this.onCanvasSizeChange);
        canvas.on(_Canvas.CanvasEvents.OnSizeChange, this.onCanvasSizeChange);
      }
      if (selectedColor && selectedColor !== prevSelectedColor) {
        canvas.setSelectedColor(selectedColor);
      }
      if (canvas !== prevCanvas || editorSize !== prevState.editorSize) {
        this.updateCanvasPosition(prevState);
      }
      var onContainerUpdate = this.props.onContainerUpdate;
      if (this.state !== prevState && onContainerUpdate) {
        onContainerUpdate({
          container: this.containerRef.current
        });
      }
    }
  }, {
    key: "updateCanvasPosition",
    value: function updateCanvasPosition() {
      var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
      var _this$props4 = this.props,
        subtractSiblingsHeight = _this$props4.subtractSiblingsHeight,
        canvas = _this$props4.canvas;
      var editorSize = this.state.editorSize;
      var ew = editorSize.width,
        eh = editorSize.height;
      if (subtractSiblingsHeight) {
        eh -= this.calculateSiblingsHeight();
      }
      if (eh <= 0 || ew <= 0) {
        logger.log('zero editor size, skipping canvas update');
        return;
      }
      var _canvas$size = canvas.size,
        cw = _canvas$size.width,
        ch = _canvas$size.height;
      var ratio = Math.max(cw / ew, ch / eh);
      var allowUpScaling = this.props.allowUpScaling;
      if (allowUpScaling) {
        var iRatio = 1 / ratio;
        canvas.setZoom(iRatio);
      } else if (ratio > 1) {
        var _iRatio = 1 / ratio;
        canvas.setZoom(_iRatio);
      } else if (prevState.ratio > 1) {
        canvas.setZoom(1);
      }
      var _canvas$getElementSiz2 = canvas.getElementSize(),
        rw = _canvas$getElementSiz2.width,
        rh = _canvas$getElementSiz2.height;
      var fixPosition = !this.props.fillContainer && (cw / ch > 1 ? rw <= ew + 0.1 : rh <= eh + 0.1);
      var canvasPosition = fixPosition ? {
        left: 0,
        top: 0
      } : {
        left: Math.max(Math.floor((ew - Math.ceil(rw)) / 2), 0),
        top: Math.max(Math.floor((eh - Math.ceil(rh)) / 2), 0)
      };
      this.setState({
        canvasPosition: canvasPosition,
        ratio: ratio
      });
    }
  }, {
    key: "render",
    value: function render() {
      logger.log('render EditorContainer');
      var _this$props5 = this.props,
        className = _this$props5.className,
        children = _this$props5.children,
        fillContainer = _this$props5.fillContainer;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _String.xc)(className, fillContainer && 'fillContainer'),
        style: this.calculateContainerStyle(),
        ref: this.containerRef
      }, /*#__PURE__*/_react["default"].createElement(CanvasPositionContext.Provider, {
        value: this.state
      }, children));
    }
  }]);
  return EditorContainer;
}(_react["default"].Component);
_defineProperty(EditorContainer, "propTypes", {
  allowUpScaling: _propTypes["default"].bool,
  subtractSiblingsHeight: _propTypes["default"].bool,
  canvas: _propTypes["default"].instanceOf(_Canvas.AbstractCanvas).isRequired,
  fillContainer: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onContainerReady: _propTypes["default"].func,
  onContainerUpdate: _propTypes["default"].func,
  selectedColor: _propTypes["default"].string,
  style: _propTypes["default"].object
});
_defineProperty(EditorContainer, "defaultProps", {
  allowUpScaling: false,
  subtractSiblingsHeight: false,
  fillContainer: false,
  selectedColor: null,
  className: '',
  onContainerReady: null,
  onContainerUpdate: null,
  style: null
});
var _default = exports["default"] = (0, _CanvasProvider.withCanvas)(EditorContainer);
var withCanvasPosition = exports.withCanvasPosition = function withCanvasPosition(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(CanvasPositionContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, state, props));
    });
  };
};